import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            'url(https://public.readdy.ai/ai/img_res/21de99f1b3a6ab595e2aec9a6807cde3.jpg)',
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30" />

      <div className="relative z-10 w-full container mx-auto px-5 sm:px-6 pt-28 pb-16 sm:pt-32 sm:pb-20">
        <div className="max-w-4xl">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-5 sm:mb-6">
            <div className="w-2 h-2 bg-yellow-400 rounded-full" />
            <span className="text-white/90 text-xs sm:text-sm font-medium">
              Ihr Bau- &amp; Sanierungspartner in Ratingen
            </span>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight drop-shadow-lg">
            Wir bauen Ihre Zukunft – mit Qualität und Präzision
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-7 sm:mb-10 leading-relaxed drop-shadow-md max-w-2xl">
            Professioneller Neubau, Sanierung und Renovierung – termingerecht, zuverlässig und aus
            einer Hand.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center gap-2 bg-[#0D2B4E] text-white px-6 py-3.5 sm:px-8 sm:py-4 rounded-lg text-sm sm:text-lg font-semibold hover:bg-[#0a2240] transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              <span>Kostenloses Angebot</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line text-lg sm:text-xl" />
              </div>
            </Link>
            <Link
              to="/leistungen"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm text-white border-2 border-white px-6 py-3.5 sm:px-8 sm:py-4 rounded-lg text-sm sm:text-lg font-semibold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Unsere Leistungen</span>
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-building-2-line text-lg sm:text-xl" />
              </div>
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 sm:bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden sm:block">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white text-3xl" />
        </div>
      </div>
    </section>
  );
}
